import React from 'react'
import { useNavigate } from 'react-router-dom'

import utils from '../utils'
import authentication from '../http/auth'
import LoadingText from '../components/LoadingText'

// HOC to inject navigate
function withRouter(Component) {
  return function ComponentWithRouterProp(props) {
    let navigate = useNavigate()
    return <Component {...props} navigate={navigate} />
  }
}

class DefaultLoginForm extends React.Component {
  state = {
    fields: null,
  };

  componentDidMount () {
    if (this.state.fields !== null) {
      return
    }

    var defaultFields = [
      {
        label: 'Username',
        name: 'username',
        placeholder: 'Username',
        required: true,
        type: 'text',
      },
      {
        label: 'Password',
        name: 'password',
        placeholder: 'Password',
        required: true,
        type: 'password',
      },
    ]

    this.setState({
      fields: defaultFields,
    })
  }

  render() {
    var fieldMarkup = null

    if (this.state.fields !== null) {
      fieldMarkup = []

      this.state.fields.forEach((field, index) => {
        var fieldId = `sp-${field.name}-${index}`
        fieldMarkup.push(
          <div key={ fieldId } className="form-group">
            <label htmlFor={ fieldId } className="col-xs-12 col-sm-4 control-label">{ field.label }</label>
            <div className="col-xs-12 col-sm-4">
              <input type={ field.type } className="form-control" id={ fieldId } name={ field.name } placeholder={ field.placeholder } required={ field.required } />
            </div>
          </div>
        )
      })

      fieldMarkup.push(
        <div key="login-button" className="form-group">
          <div className="col-sm-offset-4 col-sm-4">
            <p className="alert alert-danger" data-spIf="form.error"><span data-spBind="form.errorMessage" /></p>
            <button type="submit" className="btn btn-primary">Login</button>
          </div>
        </div>
      )
    }

    return (
      <LoginForm {...this.props}>
        <div className='sp-login-form'>
          <div className="row">
            <div className="col-xs-12">
              <div className="form-horizontal">
                { fieldMarkup ? fieldMarkup : <LoadingText /> }
              </div>
            </div>
          </div>
        </div>
      </LoginForm>
    )
  }
}

class LoginForm extends React.Component {

  state = {
    fields: {
      username: '',
      password: '',
    },
    errorMessage: null,
    isFormProcessing: false,
  }

  onFormSubmit(e) {
    e.preventDefault()

    let onSubmitSuccess = this.props.onSubmitSuccess
    let onSubmitError = this.props.onSubmitError

    let setErrorState = (recentError, newError) => {
      this.setState({
        isFormProcessing: false,
        errorMessage: (newError || recentError).message,
      })
    }

    var next = (err, data) => {
      if (err) {
        if (onSubmitError) {
          return onSubmitError({
            data: data,
            error: err,
          }, setErrorState.bind(this, err))
        }

        return setErrorState(err)
      }

      // If the user didn't specify any data,
      // then simply default to what we have in state.
      data = data || this.state.fields

      authentication.login(data.username, data.password, (loggedIn) => {
        if (!loggedIn)
        {
          let err = {'message': 'Login failed'}
          if (onSubmitError) {
            return onSubmitError({
              data: data,
              error: err,
            }, setErrorState.bind(this, err))
          }

          return setErrorState(err)
        }
        else
        {
          let performRedirect = () => this.props.navigate('/')

          if (onSubmitSuccess) {
            return onSubmitSuccess({
              data: data,
              result: {'message': 'Login succedeed'},
            }, performRedirect)
          }
          performRedirect()
        }
      })
    }

    this.setState({
      isFormProcessing: true,
    })

    if (this.props.onSubmit) {
      e.data = this.state.fields
      this.props.onSubmit(e, next)
    } else {
      next(null, this.state.fields)
    }
  }

  _mapFormFieldHandler(element, tryMapField) {
    let tryMapFormField = (name) => {
      switch(element.props.name) {
        case 'login':
        case 'username':
          tryMapField('username')
          break
        case 'password':
          tryMapField('password')
          break
        default:
          break
      }
    }

    if (typeof element.type === 'function' && utils.containsWord(element.type.name, ['input', 'field', 'text'])) {
      if (element.props && element.props.name) {
        tryMapFormField(element.props.name)
      }
    } else if (['input', 'textarea'].indexOf(element.type) > -1) {
      if (element.props.type !== 'submit') {
        tryMapFormField(element.props.name)
      }
    }
  }

  _spIfHandler(action, element) {
    var test = null

    switch (action) {
      case 'form.processing':
        test = this.state.isFormProcessing
        break
      case 'form.error':
        test = this.state.errorMessage !== null
        break
      default:
        break
    }

    return test
  }

  _spBindHandler(bind, element) {
    var result = false

    switch (bind) {
      case 'form.errorMessage':
        {
          let className = element.props ? element.props.className : undefined
          result = <span className={className}>{this.state.errorMessage}</span>
          break
        }
      default:
        break
    }

    return result
  }

  render() {
    if (this.props.children) {
      let selectedProps = utils.excludeProps(['redirectTo', 'hideSocial', 'onSubmit', 'onSubmitError', 'onSubmitSuccess', 'children'], this.props)

      return (
        <form onSubmit={this.onFormSubmit.bind(this)} {...selectedProps}>
          {utils.makeForm(this, this._mapFormFieldHandler.bind(this), this._spIfHandler.bind(this), this._spBindHandler.bind(this))}
        </form>
      )
    } else {
      return <DefaultLoginForm {...this.props} />
    }
  }
}

export default withRouter(LoginForm)
